// extracted by mini-css-extract-plugin
module.exports =  {"formulaError":"formulaError_KkjaawT1"};